<template>
  <div class="pr-page">
    <van-nav-bar
      style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7; z-index: 10"
      title="个人报表"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="pr-pad" />

    <div class="pr-inner">
      <div class="pr-card pr-card--head">
        <div class="pr-tabs" role="tablist">
        <button
          v-for="t in timeTabs"
          :key="t.id"
          type="button"
          role="tab"
          :aria-selected="timeRange === t.id"
          :class="['pr-tab', { 'pr-tab--on': timeRange === t.id }]"
          @click="onTab(t.id)"
        >
          {{ t.name }}
        </button>
        </div>
        <p class="pr-hint-sub">{{ rangeSubtitle }}</p>
      </div>

      <div class="pr-grid pr-grid--5">
        <div v-for="(row, i) in periodGridRows" :key="'p' + i" :class="['pr-cell', row.span && 'pr-cell--wide']">
          <div class="pr-cell__label">{{ row.label }}</div>
          <div :class="['pr-cell__val', valueTone(period[row.key], row.money)]">
            {{ row.money ? formatMoney(period[row.key]) : formatCount(period[row.key]) }}
          </div>
        </div>
      </div>

      <div class="pr-sec">
        <h2 class="pr-sec__tit">盈亏报表</h2>
        <p class="pr-sec__desc">账户累计（自注册起）</p>
      </div>

      <div class="pr-grid">
        <div v-for="(row, i) in totalGridRows" :key="'a' + i" class="pr-cell">
          <div class="pr-cell__label">{{ row.label }}</div>
          <div :class="['pr-cell__val', valueTone(total[row.key], row.money)]">
            {{ row.money ? formatMoney(total[row.key]) : formatCount(total[row.key]) }}
          </div>
        </div>
      </div>

      <div class="pr-net">
        <div class="pr-net__label">净输赢</div>
        <div :class="['pr-net__val', valueTone(period.win_loss, true)]">
          {{ formatMoney(period.win_loss) }}
        </div>
        <p class="pr-net__formula">
          净输赢 = 当前所选时间范围内，游戏注单中的输赢合计（与列表中「游戏输赢」一致）
        </p>
      </div>

      <div class="pr-foot">
        <span class="pr-foot__ico" aria-hidden="true">i</span>
        <p class="pr-foot__txt">提示：注单数据可能存在同步延迟，具体以各游戏内查询为准。</p>
      </div>
    </div>
    <div class="pr-bottom-space" />
  </div>
</template>
<script>
export default {
  name: 'personalReport',
  data() {
    return {
      timeRange: 'today',
      timeTabs: [
        { id: 'today', name: '今天' },
        { id: 'yesterday', name: '昨天' },
        { id: 'this_week', name: '本周' },
        { id: 'last_week', name: '上周' },
      ],
      period: {},
      total: {},
    };
  },
  computed: {
    rangeSubtitle() {
      const m = {
        today: '以下为今日存提款与注单数据',
        yesterday: '以下为昨日存提款与注单数据',
        this_week: '以下为本周（周一至今日）的存提款与注单数据',
        last_week: '以下为上一自然周（周一至周日）的存提款与注单数据',
      };
      return m[this.timeRange] || m.today;
    },
    periodGridRows() {
      return [
        { label: '充值 (元)', key: 'recharge_sum', money: true },
        { label: '取款 (元)', key: 'withdraw_sum', money: true },
        { label: '投注额 (元)', key: 'bet_sum', money: true },
        { label: '有效投注 (元)', key: 'valid_bet_sum', money: true },
        { label: '游戏输赢 (元)', key: 'win_loss', money: true, span: true },
      ];
    },
    totalGridRows() {
      return [
        { label: '存款次 (次)', key: 'recharge_times', money: false },
        { label: '提款次 (次)', key: 'withdraw_times', money: false },
        { label: '总存款 (元)', key: 'recharge_sum', money: true },
        { label: '总提款 (元)', key: 'withdraw_sum', money: true },
        { label: '总有效投注 (元)', key: 'valid_bet_sum', money: true },
        { label: '总输赢 (元)', key: 'win_loss', money: true },
      ];
    },
  },
  created() {
    this.load();
  },
  methods: {
    onTab(id) {
      if (this.timeRange === id) return;
      this.timeRange = id;
      this.load();
    },
    formatMoney(v) {
      const n = parseFloat(v);
      if (v === null || v === undefined || (typeof v === 'string' && v === '') || isNaN(n)) {
        return '0.00';
      }
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatCount(v) {
      const n = parseInt(v, 10);
      if (isNaN(n)) return '0';
      return n.toLocaleString('zh-CN');
    },
    valueTone(v, isMoney) {
      if (!isMoney) return '';
      const n = parseFloat(v);
      if (isNaN(n) || n === 0) return '';
      if (n < 0) return 'is-neg';
      if (n > 0) return 'is-pos';
      return '';
    },
    load() {
      const that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/personalReport', { timeRange: that.timeRange })
        .then(res => {
          that.$parent.hideLoading();
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message || '加载失败');
            return;
          }
          const d = res.data || {};
          that.period = d.period || d.today || {};
          that.total = d.total || {};
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/* 与 fanshui / transRecord 等页一致的浅色风格 */
.pr-page {
  min-height: 100vh;
  width: 100%;
  background: rgb(237, 241, 255);
  box-sizing: border-box;
  padding-bottom: 16px;
}

.pr-pad {
  height: 46px;
}

.pr-inner {
  width: 95%;
  min-width: 250px;
  max-width: 480px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 0 8px;
}

.pr-card {
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px 10px 4px;
  margin-bottom: 10px;
  box-shadow: 0 0.04rem 0.2rem 0 rgba(93, 114, 162, 0.08);
  &--head {
    padding-bottom: 10px;
  }
}

.pr-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.pr-tab {
  flex: 1;
  min-height: 0.8rem;
  padding: 6px 2px;
  font-size: 0.3rem;
  color: #a2aec8;
  background: #f7f8fc;
  border: 1px solid transparent;
  border-radius: 1.1rem;
  cursor: pointer;
  line-height: 1.2;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  &--on {
    color: #5d75a2;
    font-weight: 600;
    background: #e8ecf4;
    border-color: rgba(93, 117, 162, 0.25);
  }
}

.pr-hint-sub {
  font-size: 0.26rem;
  color: #a2aec8;
  line-height: 1.5;
  margin: 0;
  padding: 0 4px 2px;
}

.pr-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
  &--5 .pr-cell--wide {
    grid-column: 1 / -1;
  }
}

.pr-cell {
  background: #fff;
  border-radius: 10px;
  padding: 10px 10px 12px;
  box-sizing: border-box;
  min-height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0.04rem 0.2rem 0 rgba(93, 114, 162, 0.08);
  border: 1px solid #f0f2f6;
}

.pr-cell__label {
  font-size: 0.26rem;
  color: #7a889e;
  line-height: 1.3;
  margin-bottom: 6px;
}

.pr-cell__val {
  font-size: 0.4rem;
  font-weight: 700;
  color: #4e6693;
  line-height: 1.2;
  word-break: break-all;
  &.is-neg {
    color: #e24a3d;
  }
  &.is-pos {
    color: #3a9b6f;
  }
}

.pr-sec {
  margin: 4px 0 10px;
  &__tit {
    font-size: 15px;
    font-weight: 600;
    color: #4e6693;
    margin: 0 0 4px;
    padding-left: 8px;
    border-left: 3px solid #5d75a2;
    line-height: 1.2;
  }
  &__desc {
    font-size: 12px;
    color: #a2aec8;
    margin: 0 0 0;
    padding-left: 11px;
  }
}

.pr-net {
  margin-top: 6px;
  padding: 12px 12px 12px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0.04rem 0.2rem 0 rgba(93, 114, 162, 0.08);
  border: 1px solid #f0f2f6;
  &__label {
    font-size: 0.3rem;
    color: #7a889e;
    margin-bottom: 4px;
  }
  &__val {
    font-size: 0.44rem;
    font-weight: 700;
    color: #cf866b;
    margin-bottom: 8px;
    &.is-neg {
      color: #e24a3d;
    }
    &.is-pos {
      color: #3a9b6f;
    }
  }
  &__formula {
    font-size: 0.24rem;
    color: #a2aec8;
    line-height: 1.5;
    margin: 0;
  }
}

.pr-foot {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 0 4px 8px;
  &__ico {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #5d75a2;
    color: #5d75a2;
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    font-style: italic;
    font-weight: 600;
  }
  &__txt {
    font-size: 0.24rem;
    line-height: 1.5;
    color: #a2aec8;
    margin: 0;
  }
}

.pr-bottom-space {
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/personalReport.vue